<div id="print-apartment-round">
  <div class="page">
    <header>
      <h1 class="print">{{ 'report.new.list.apartmentRound' | translate }}</h1>
      <h2>{{ 'report.apartmentRound.printTitle.' + report().type | translate }}</h2>
      <h2>{{ report().date | timestamp:'d.M.yyyy' }}</h2>
      @if (siteImage()) {
        <div class="print">
          <img [src]="siteImage()" />
        </div>
      }
    </header>
  </div>
  <div class="page">
    <table>
      <tr class="header">
        <td colspan="3">{{ 'home.renovation.participants' | translate }}</td>
      </tr>
      @for (user of report().participants; track $index) {
        <tr>
          <td>
            {{ user.name }}
          </td>
          <td>
            @if (user.company) {
              {{ user.company }}<br />
            }
            {{ user.role }}
          </td>
          <td>
            {{ user.email }}
          </td>
        </tr>
      }
    </table>
    <table>
      <tr class="header">
        <td>{{ 'report.apartmentRound.summary' | translate }}</td>
      </tr>
      <tr>
        <td>{{ report().summary }}</td>
      </tr>
    </table>
  </div>
  @if (report().areas.length > 0) {
    @for (area of report().areas; track $index) {
      <div class="page">
        @for (type of area.type | keyvalue; track $index) {
          <h4>{{ 'report.apartmentRound.items.' + type.key | translate }}</h4>
          <table>
            <tr class="header">
              <td>{{ 'report.apartmentRound.roomNumber' | translate }}</td>
              <td>{{ 'report.apartmentRound.blocked' | translate }}</td>
            </tr>
            <tr>
              <td>{{ area.name }}</td>
              <td>{{ type.value.blocked }}</td>
            </tr>
          </table>
          @if (type.value.rooms?.length > 0) {
            <h4>{{ 'report.apartmentRound.inRoom.' + type.key | translate }}</h4>
          }
          @for (room of type.value.rooms; track $index) {
            <table>
              <tr class="header">
                <td>{{ 'report.apartmentRound.area' | translate }}</td>
                <td>{{ 'report.apartmentRound.areaExtras' | translate }}</td>
              </tr>
              <tr>
                <td>{{ room.name }}</td>
                <td>{{ room.extras }}</td>
              </tr>
              <tr class="header">
                <td>{{ 'report.apartmentRound.condition' | translate }}</td>
                <td>{{ 'report.apartmentRound.conditionExtras' | translate }}</td>
              </tr>
              <tr>
                <td>{{ room.condition }}</td>
                <td>{{ room.conditionExtras }}</td>
              </tr>
            </table>
            <div class="flex">
              @for (image of room.images; track $index) {
                <img [src]="image"
                  class="review-image" />
              }
            </div>
          }
        }
      </div>
    }
  }
</div>